var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import LocalStorageService from "../services/localStorage";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var getHeader = function () {
    return {
        "Content-Type": "application/json",
        Accept: "application/json, text/plain, */*",
        ip: "123456789",
        "X-Client-Id": lsLogin.getUserLoginStored().clientId,
        "x-no-cache": "true",
        Authorization: "Bearer " + lsLogin.getUserLoginStored().token,
    };
};
export var getHeaderUpload = function () {
    return {
        ip: "123456789",
        "X-Client-Id": lsLogin.getUserLoginStored().clientId,
        Authorization: "Bearer " + lsLogin.getUserLoginStored().token,
    };
};
export var getHeader2 = function (contentType) {
    return {
        "Content-Type": "application/".concat(contentType),
        Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ip: "123456789",
        "X-Client-Id": lsLogin.getUserLoginStored().clientId,
        Authorization: "Bearer " + lsLogin.getUserLoginStored().token,
    };
};
export var getHeaderNotification = function () {
    var _a, _b;
    var stored = localStorage.getItem("assurehub");
    var userId = stored ? (_b = (_a = JSON.parse(stored)) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.id : "";
    return __assign(__assign({}, getHeader()), { "X-User-ID": userId });
};
export var getHeaderLogin = function () {
    return {
        "Content-Type": "application/json",
        Accept: "application/json, text/plain, */*",
        ip: "123456789",
    };
};
